import { useAppSelector } from "../../../services/hooks/useReduxHooks";
import { BeansIcon, BunIcon, DrumsticksIcon, MileStone } from "./loyalty.icons";

/**
 * Renders the points symbol the restaurant configured in loyalty-service
 * (`tierSystem.pointsIcon`). Falls back to the star, which is both the
 * loyalty-service default and the only glyph the legacy pointing system has.
 */
export const LoyaltyPointsIcon = () => {
  const pointsIcon = useAppSelector(
    (state) => state.loyaltyTierSystem.data?.pointsIcon
  );

  switch (pointsIcon) {
    case "DRUMSTICK":
      return <DrumsticksIcon />;
    case "BEANS":
      return <BeansIcon />;
    case "BUN":
      return <BunIcon />;
    default:
      return <MileStone />;
  }
};
